import Vue from 'vue'
import Vuex from 'vuex'

import auth from '@/modules/auth'
import app from '@/modules/app'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    notification: {
      disable: true
    },
    lists: {
      disable: true
    },
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth, app
  },
})
